import React, { PureComponent } from 'react'
import { Paper, ListItem, Grid, MenuItem, Typography, withStyles, Tooltip } from '@material-ui/core'

// constants
import { getUsStates, usStates, TimeZones } from '../../utils/constants'

// api hits
import { uploadCompanyLogo } from '../../api/assets'

// utils
import { hasAccess } from '../../utils/api'
//import { convertArrayToOptions } from '../../utils/array';

// local components
import EditActionComponent from '../common/EditActionComponent'

import { EditableTextField, EditableSelect, EditableSwitch } from '../common/EditableComponents'
import { EditableColorPicker, ColorSwatch } from '../common/ColorPicker'
import { EditableImageUploader, ImagePreview } from '../common/ImageUploader'
import ReactPhoneInput from '../common/ReactPhoneInput'
import { openErrorMessage } from '../../actions/message'
import InfoIcon from '@material-ui/icons/Info'

const statesList = getUsStates()

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip)

const ConfigurationTooltip = ({ text }) => {
  return (
    <HtmlTooltip placement="top-start" title={<Typography color="inherit">{text}</Typography>}>
      <InfoIcon style={{ color: '#03a9f4' }} />
    </HtmlTooltip>
  )
}

class CompanyInfo extends PureComponent {
  state = {
    salesPerson: '',
    infoAutoSendOnfleet1:
      '• Auto Send to Onfleet - Onfleet Team (Global Settings > Current Shop Settings > Shop Information) must be set to determine which team is assigned automatically to each order.',
    infoAutoSendOnfleet2:
      '• For each specified region, employees must be set up in Onfleet (Global Settings > Integration Settings > Onfleet > Employees).',
    infoAutoSendOnfleet3:
      '• Employees set up with Onfleet must be assigned a terminal (Global Settings > Manage Employees) with a region associated inventory (Global Settings > Current Shop Settings > Inventory).',
  }

  onChange = (key, isCheckBox) => (e) => {
    if (key === 'salesPerspn') {
      this.setState({ salesPerson: e.target.value })
    }
    const value = isCheckBox ? e.target.checked : e.target.value

    if (key === 'autoAcceptIncomingOrders') {
      this.props.onChange('autoAcceptEmployee', '')
    }

    if (key === 'autoPackedIncomingOrders') {
      this.props.onChange('autoPackedEmployee', '')
    }

    this.props.onChange(key, value)
  }

  onChangeMultilicense = (key, isCheckBox) => (e) => {
    const value = isCheckBox ? e.target.checked : e.target.value

    this.props.onChangeMultilicense(key, value)
  }

  onChangeAddress = (key) => (e) => {
    const { data } = this.props
    const { address } = data

    let newAddress = { ...address }

    newAddress = {
      ...newAddress,
      [key]: e.target.value,
    }

    this.props.onChange('address', newAddress)
  }

  onChangePhone = (e, key) => {
    this.props.onChange(key, e)
  }

  onColorChange = (key) => (color) => {
    this.props.onChange(key, color.hex)
  }

  onSave = () => {
    const { data } = this.props
    if (data.autoAcceptIncomingOrders && !data.autoAcceptEmployee) {
      return this.props.dispatch(openErrorMessage('Select one employee for the auto accept'))
    }

    if (data.autoPackedIncomingOrders && !data.autoPackedEmployee) {
      return this.props.dispatch(openErrorMessage('Select one employee for the auto packed'))
    }

    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  getEmployeeName = (employeeId) => {
    const employee = this.props.adminsEmployees.find((e) => e.id === employeeId)
    return employee ? `${employee.firstName} ${employee.lastName}` : ''
  }

  render() {
    const {
      editMode = false,
      data = {},
      companyFeatures = {},
      multilicense,
      metrcSettings,
      shops = {},
      employee,
    } = this.props

    const { availableApps = [] } = companyFeatures

    const { address = {} } = data
    //let emps = this.props.employees.map(emp => ({ ...emp, name: `${emp.firstName} ${emp.lastName}` }))
    //const employees = convertArrayToOptions(emps)

    // const empMap = employees && employees.forEach(emp => { [emp.id] = emp.name }) || {}
    //const selectedSalesperson = data.salesPerson && employees && employees.find(emp => (emp.value == data.salesPerson)) || employees[0]
    let showMultilicenseFeature = false

    if (metrcSettings && metrcSettings.enabled && metrcSettings.stateCode == 'CA') {
      for (let i = 0; i < shops.length; i++) {
        if (
          shops[i].active &&
          shops[i].enableMetrc &&
          shops[i].address.state == 'CA' &&
          shops[i].appTarget == 'Grow' &&
          employee.shops.includes(shops[i].id)
        ) {
          showMultilicenseFeature = true
        }
      }
    }

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {hasAccess() ? (
              <div className="pull-right margin-bottom-small">
                <EditActionComponent
                  onSave={this.onSave}
                  onCancel={this.onCancel}
                  onEdit={this.props.enableEdit}
                  editMode={editMode}
                />
              </div>
            ) : (
              <div className="pull-right margin-bottom-small"></div>
            )}
          </Grid>
        </Grid>
        <Grid className="companyInfo" container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Company Name
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.name}
                      editMode={editMode}
                      value={data.name}
                      onChange={this.onChange('name')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Website
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.website}
                      editMode={editMode}
                      value={data.website}
                      onChange={this.onChange('website')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Email
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={data.email}
                      editMode={editMode}
                      value={data.email}
                      onChange={this.onChange('email')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Phone
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    {editMode ? (
                      <ReactPhoneInput
                        defaultCountry={'us'}
                        placeholder={'Phone Number'}
                        onChange={(e) => this.onChangePhone(e, 'phoneNumber')}
                        preferredCountries={['us', 'ca']}
                        inputClass="global-phone-input"
                        name="phoneNumber"
                        value={(data && data.phoneNumber) || ''}
                        containerClass="form-control phone-input"
                      />
                    ) : (
                      `${data && data.phoneNumber}`
                    )}
                    {/* <EditableInput
                                            valueToRender={data.phoneNumber}
                                            editMode={editMode}
                                            value={data.phoneNumber}
                                            onChange={this.onChange('phoneNumber')}
                                            id="formatted-text-mask-input"
                                            inputComponent={PhoneMask}
                                            className="form-control"
                                        /> */}
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Company Logo
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableImageUploader
                      editMode={editMode}
                      valueToRender={<ImagePreview src={data.logoURL} />}
                      src={data.logoURL}
                      imageUploadAPI={uploadCompanyLogo}
                    />
                  </Grid>
                </Grid>
              </ListItem>

              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Preferred Email Color
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableColorPicker
                      valueToRender={<ColorSwatch color={data.preferredEmailColor} />}
                      color={data.preferredEmailColor}
                      onColorChange={this.onColorChange('preferredEmailColor')}
                      editMode={editMode}
                    />
                  </Grid>
                </Grid>
              </ListItem>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Address
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={address.address}
                      editMode={editMode}
                      value={address.address}
                      onChange={this.onChangeAddress('address')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    City
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={address.city}
                      editMode={editMode}
                      value={address.city}
                      onChange={this.onChangeAddress('city')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Zip Code
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableTextField
                      valueToRender={address.zipCode}
                      editMode={editMode}
                      value={address.zipCode}
                      onChange={this.onChangeAddress('zipCode')}
                      type="text"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    State
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableSelect
                      value={address.state}
                      onChange={this.onChangeAddress('state')}
                      valueToRender={usStates[address.state]}
                      editMode={editMode}
                    >
                      {statesList.map((item, index) => {
                        return (
                          <MenuItem key={index} value={item.value}>
                            {item.label}
                          </MenuItem>
                        )
                      })}
                    </EditableSelect>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Time Zone
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableSelect
                      value={data.timeZone}
                      onChange={this.onChange('timeZone')}
                      valueToRender={data.timeZone}
                      editMode={editMode}
                      displayEmpty={true}
                    >
                      <MenuItem value={''}>Select TimeZone</MenuItem>
                      {TimeZones.map((timezone, index) => {
                        return (
                          <MenuItem key={index} value={timezone.value}>
                            {timezone.label}
                          </MenuItem>
                        )
                      })}
                    </EditableSelect>
                  </Grid>
                </Grid>
              </ListItem>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                    Company Pricing Option
                  </Grid>
                  <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                    <EditableSelect
                      value={data.pricingOpt}
                      onChange={this.onChange('pricingOpt')}
                      valueToRender={`${data.pricingOpt || ''} pricing`}
                      editMode={editMode}
                    >
                      <MenuItem value="Normal">Normal Pricing</MenuItem>
                      <MenuItem value="Discounted">Discounted Pricing</MenuItem>
                    </EditableSelect>
                  </Grid>
                </Grid>
              </ListItem>
              {/* <ListItem>
                                <Grid container>
                                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                                        Sales Person
                                    </Grid>
                                    <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                                        <EditableSelect
                                            value={data.salesPerson}
                                            onChange={this.onChange('salesPerson')}
                                            valueToRender={selectedSalesperson && selectedSalesperson.label || ''}
                                            editMode={editMode}
                                        >
                                            {employees && employees.map(emp => <MenuItem value={emp.value}>{emp.label}</MenuItem>)}
                                        </EditableSelect>
                                    </Grid>
                                </Grid>
                            </ListItem>
                            {/* <ListItem> 
                            <Grid container>
                                <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                                    Contact Person
                                    </Grid>
                                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                                    <EditableSelect
                                        value={data.contactPerson}
                                        onChange={this.onChange('contactPerson')}
                                        valueToRender={data.contactPerson || ''}
                                        editMode={editMode}
                                    >
                                        <MenuItem value="Normal">Normal Pricing</MenuItem>

                                    </EditableSelect>
                                </Grid>
                            </Grid>
                            </ListItem> 
                            <ListItem>
                            <Grid container>
                                <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                                    Payment term
                                    </Grid>
                                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                                    <EditableSelect
                                        value={data.defaultPaymentTerm}
                                        onChange={this.onChange('defaultPaymentTerm')}
                                        valueToRender={data.defaultPaymentTerm && data.defaultPaymentTerm.replace(/_/g, " ") || ''}
                                        editMode={editMode}
                                    >
                                        {paymentTerms.map(term => <MenuItem value={term.value}>{term.label}</MenuItem>)}
                                    </EditableSelect>
                                </Grid>
                            </Grid>
                            </ListItem>*/}
            </Paper>
          </Grid>
          {availableApps.length > 0 &&
            availableApps &&
            availableApps.indexOf('Grow') >= 0 &&
            showMultilicenseFeature && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Paper className="paper-page">
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                        Multi-license Feature
                      </Grid>
                      <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                        <EditableSwitch
                          valueToRender={multilicense.enableMultilicense ? 'Enabled' : 'Disabled'}
                          checked={multilicense.enableMultilicense}
                          editMode={editMode}
                          onChange={this.onChangeMultilicense('enableMultilicense', true)}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                </Paper>
              </Grid>
            )}
          {availableApps.length > 0 && availableApps && availableApps.indexOf('Dispatch') >= 0 && (
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Paper className="paper-page dispatch-config">
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography className="margin-left-small" variant="headline">
                    Dispatch Configuration
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                        <Typography variant="title" gutterBottom>
                          Type
                        </Typography>
                      </Grid>
                      <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
                        <Typography variant="title" gutterBottom>
                          Status
                        </Typography>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                        Auto Accept Member
                      </Grid>
                      <Grid className="editField" item xs={5} sm={5} md={5} lg={5}>
                        <EditableSwitch
                          valueToRender={data.autoAcceptMember ? 'Enabled' : 'Disabled'}
                          checked={data.autoAcceptMember}
                          editMode={editMode}
                          onChange={this.onChange('autoAcceptMember', true)}
                        />
                      </Grid>
                      <Grid className="tooltip" item xs={1}>
                        <ConfigurationTooltip
                          text={
                            'When enabled, new members created from incoming orders will be automatically accepted in BLAZE.'
                          }
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                        Auto Accept Incoming Orders
                      </Grid>
                      <Grid className="editField" item xs={5} sm={5} md={5} lg={5}>
                        <EditableSwitch
                          valueToRender={data.autoAcceptIncomingOrders ? 'Enabled' : 'Disabled'}
                          checked={data.autoAcceptIncomingOrders}
                          editMode={editMode}
                          onChange={this.onChange('autoAcceptIncomingOrders', true)}
                        />
                      </Grid>
                      <Grid className="tooltip" item xs={1}>
                        <ConfigurationTooltip
                          text={
                            'When enabled Incoming Orders will be automatically accepted once received in BLAZE.'
                          }
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  {data.autoAcceptIncomingOrders && (
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                          Auto Accept Employee
                        </Grid>
                        <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
                          <EditableSelect
                            value={data.autoAcceptEmployee}
                            onChange={this.onChange('autoAcceptEmployee')}
                            valueToRender={this.getEmployeeName(data.autoAcceptEmployee)}
                            editMode={editMode}
                          >
                            {this.props.adminsEmployees.map((item, index) => {
                              return (
                                <MenuItem key={index} value={item.id}>
                                  {item.firstName} {item.lastName}{' '}
                                </MenuItem>
                              )
                            })}
                          </EditableSelect>
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                        Auto Assign based on Regions - Incoming Orders
                      </Grid>
                      <Grid className="editField" item xs={5} sm={5} md={5} lg={5}>
                        <EditableSwitch
                          valueToRender={data.autoAssignIncomingOrders ? 'Enabled' : 'Disabled'}
                          checked={data.autoAssignIncomingOrders}
                          editMode={editMode}
                          onChange={this.onChange('autoAssignIncomingOrders', true)}
                        />
                      </Grid>
                      <Grid className="tooltip" item xs={1}>
                        <ConfigurationTooltip
                          text={
                            'When Enabled Online orders will have their shop, inventory and region assigned based on the order address after the order has been accepted.'
                          }
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                        Auto Assign based on Regions - Regular Orders
                      </Grid>
                      <Grid className="editField" item xs={5} sm={5} md={5} lg={5}>
                        <EditableSwitch
                          valueToRender={data.autoAssignOrders ? 'Enabled' : 'Disabled'}
                          checked={data.autoAssignOrders}
                          editMode={editMode}
                          onChange={this.onChange('autoAssignOrders', true)}
                        />
                      </Grid>
                      <Grid className="tooltip" item xs={1}>
                        <ConfigurationTooltip
                          text={
                            'When Enabled manually created orders will have their shop, inventory and region assigned based on the order address.'
                          }
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={6}>
                        Auto Assign Drivers - Incoming Orders
                      </Grid>
                      <Grid className="editField" item xs={5}>
                        <EditableSwitch
                          valueToRender={data.autoAssignDrivers ? 'Enabled' : 'Disabled'}
                          checked={data.autoAssignDrivers}
                          editMode={editMode}
                          onChange={this.onChange('autoAssignDrivers', true)}
                        />
                      </Grid>
                      <Grid className="tooltip" item xs={1}>
                        <ConfigurationTooltip
                          text={
                            'For drivers to correctly be auto assigned to orders, the driver must be assigned to a terminal with the same Region and Inventory assignment as the order.'
                          }
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container>
                      <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                        Auto Pack Incoming Orders
                      </Grid>
                      <Grid className="editField" item xs={5} sm={5} md={5} lg={5}>
                        <EditableSwitch
                          valueToRender={data.autoPackedIncomingOrders ? 'Enabled' : 'Disabled'}
                          checked={data.autoPackedIncomingOrders}
                          editMode={editMode}
                          onChange={this.onChange('autoPackedIncomingOrders', true)}
                        />
                      </Grid>
                      <Grid className="tooltip" item xs={1}>
                        <ConfigurationTooltip
                          text={
                            "When enabled Incoming Orders will automatically be flagged as 'Packed' in BLAZE."
                          }
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  {data.autoPackedIncomingOrders && (
                    <ListItem>
                      <Grid container>
                        <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                          Auto Pack Employee
                        </Grid>
                        <Grid className="editField" item xs={5} sm={5} md={5} lg={5}>
                          <EditableSelect
                            value={data.autoPackedEmployee}
                            onChange={this.onChange('autoPackedEmployee')}
                            valueToRender={this.getEmployeeName(data.autoPackedEmployee)}
                            editMode={editMode}
                          >
                            {this.props.adminsEmployees.map((item, index) => {
                              return (
                                <MenuItem key={index} value={item.id}>
                                  {item.firstName} {item.lastName}{' '}
                                </MenuItem>
                              )
                            })}
                          </EditableSelect>
                        </Grid>
                        <Grid className="tooltip" item xs={1}>
                          <ConfigurationTooltip
                            text={
                              "This is the employee that will be shown as having packed automatically packed orders when 'Auto Pack Incoming Orders' is enabled."
                            }
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}
                </Grid>
              </Paper>
            </Grid>
          )}
        </Grid>
      </div>
    )
  }
}

export default CompanyInfo



// WEBPACK FOOTER //
// ./src/components/CompanyInfo/index.js